export const FETCH_SPINNER_LOADING = 'FETCH_SPINNER_LOADING';
export const SET_SPINNER_LOADING = 'SET_SPINNER_LOADING';
export const FETCH_API_VERSIONS = 'FETCH_API_VERSIONS';
export const LOG_LEVEL_ERROR = 'ERROR';
export const LOG_LEVEL_WARN = 'WARN';
export const LOG_LEVEL_INFO = 'INFO';
